import { ChangeDetectorRef, Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { DynamicBrandingService } from '@boxx/dynamic-branding';
import { BoxxGMBOAuthService, IGoogleOAuthResponse } from '@boxx/OAuth';
import { IBusinessAdditionalInfoProps, OnboardingStore } from '@boxx/onboarding-core';
import { AlertController, ModalController, Platform, PopoverController } from '@ionic/angular';
import { Observable, Subject } from 'rxjs';
import { GMB_SERVICE, IGmbLocation, IGmbService } from '@boxx/gmb-core';
import { takeUntil, withLatestFrom } from 'rxjs/operators';
import { LocalStorageNativeService } from 'src/services/NativeLocalStorage.service';
import { TranslateService } from '@ngx-translate/core';
import { BoxxUtilsService } from 'src/services/BoxxUtils.service';
import { Router } from '@angular/router';
import { GmbAccountSelectComponent } from '@app/pages/settings/components/gmb-location-picker/gmb-account-select.component';

@Component({

  selector: 'boxx-gmb-initial-component',
  templateUrl: './gmb-initial-component.html',
  styleUrls: ['./gmb-initial-component.scss'],
})
export class GmbInitialComponent implements OnInit, OnDestroy {
  brandLogo = '';
  appName = '';
  appNameUpper = '';
  allowClose: boolean;

  oauthLibLoaded = false;
  isApp: boolean;

  private translations: any;
  private destroyed$ = new Subject<boolean>();
  businessConfigState: IBusinessAdditionalInfoProps;

  constructor(
    public storageService: LocalStorageNativeService,
    private boxxGMBOAuthService: BoxxGMBOAuthService,
    @Inject(GMB_SERVICE) private ld3GmbService: IGmbService,
    private boxxUtils: BoxxUtilsService,
    private modalCtrl: ModalController,
    private dBrandingService: DynamicBrandingService,
    private cdr: ChangeDetectorRef,
    private translateService: TranslateService,
    private onboardingStore: OnboardingStore,
    private platform: Platform,
    private router: Router,
    private alertCtrl: AlertController,

  ) {
    this.dBrandingService.appCopies$.subscribe(hasChanges => {
      if (hasChanges) {
        this.brandLogo = this.dBrandingService.logo;
        this.appName = this.dBrandingService.tradename;
        this.appNameUpper = this.dBrandingService.tradename.toUpperCase();
      }
    });

    this.translateService
    .get(['ONBOARDING_MODULE', 'ACTIONS'])
    .pipe(takeUntil(this.destroyed$))
    .subscribe((t) => (this.translations = t));
  }

  ionViewWillEnter() {
    this.onboardingStore.businessConfig.modulesCompletenes$
      .subscribe((state) => {
        this.businessConfigState = state;
      })
      .unsubscribe();
  }

  ngOnInit() {
    this.isApp = document.URL.indexOf('http') !== 0;
    if(this.platform.is('ios') && this.isApp){
      this.oauthLibLoaded = true;
      return;
    }
    this.boxxGMBOAuthService.oauthLibLoaded$.pipe(takeUntil(this.destroyed$)).subscribe(loaded => {
      if (loaded) {
        this.oauthLibLoaded = true;
        this.cdr.detectChanges();
      }
    });
  }
  
  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  close(){
    
  }

  async startGmbSync() {
    try {
      await this.boxxUtils.handleLoading(true);

      setTimeout(async () => {
        await this.boxxUtils.handleLoading(false);
      }, 4000);


      const gmbOAuthResp = await this.gmbOAuth();

      if (!gmbOAuthResp) {
        //await this.boxxUtils.handleLoading(false);
        return;
      }
   
      //alert(JSON.stringify(gmbOAuthResp));
      const locations = await this.ld3GmbService
        .setAuthCode({
          code: gmbOAuthResp.authResponse.code,
          redirect:
            window.location.origin === 'capacitor://localhost'
              ? 'http://localhost'
              : window.location.origin,
        })
        .toPromise();


      //await this.boxxUtils.handleLoading(false);

      const data = await this.selectLocationModal(locations);
    
      if (!data) {
        return;
      }

      const selectedLocation = locations[data.index];

      await this.boxxUtils.handleLoading(true);
      const respData = await this.ld3GmbService.setSelectedLocation(selectedLocation).toPromise();
      await this.boxxUtils.handleLoading(false);
      if(respData){
        this.onboardingStore.businessConfig.getBusinesData();
        this.onboardingStore.businessConfig.getGmbLocationStatus();
        this.boxxUtils.showAlert({
          header: this.translations.ONBOARDING_MODULE.GMB_SURVEY.gmbOAuthConfirm_ALERT.header,
          message: this.translations.ONBOARDING_MODULE.GMB_SURVEY.gmbOAuthConfirm_ALERT.message,
          buttons: [
            {
              text: this.translations.ACTIONS.ok,
              handler: (blah) => {                
                this.modalCtrl.dismiss();
              }
            },
          ],
          backdropDismiss: false
        });
        //window.location.reload();
      }


      //TODO: what to do next???
    } catch (e) {
      await this.boxxUtils.handleLoading(false);
      this.boxxUtils.showToastError({
        message: e?.message || e,
      });
    }
  }

  async craetaGmbSync(){
    this.modalCtrl.dismiss();
    this.router.navigateByUrl('/create-gmb');
  }

  async skip(){

    const alert = await this.alertCtrl.create({
      header: this.translations.ONBOARDING_MODULE.GMB_SURVEY.skip_PROMPT.header,
      message: this.translations.ONBOARDING_MODULE.GMB_SURVEY.skip_PROMPT.message,
      buttons: [
        {
          text: this.translations.ACTIONS.ok,
          handler: () => {
            this.modalCtrl.dismiss();
          },
          cssClass: 'boxx-main-btn',
        },
      ],
    });

    await alert.present();

    // this.modalCtrl.dismiss({ data: 1});
    // //this.router.navigateByUrl('tabs/account/setup-wizard');

    // const nextRoute = 'onboarding/business-configuration';

    // this.router.navigateByUrl(nextRoute, {
    //   skipLocationChange: true,
    //   replaceUrl: true,
    // });
  }

  private async gmbOAuth(): Promise<IGoogleOAuthResponse> {
    try {
      return this.boxxGMBOAuthService.oauth();
    } catch (e) {
      if (e?.error === 'access_denied') {
        this.boxxUtils.showAlert({
          header: this.translations.ONBOARDING_MODULE.GMB_SURVEY.gmbOAuth_ALERT.header,
          message: this.translations.ONBOARDING_MODULE.GMB_SURVEY.gmbOAuth_ALERT.message,
          buttons: [
            {
              text: this.translations.ACTIONS.close,
            },
          ],
        });
      } else {
        this.boxxUtils.showToastError({
          message: e?.error,
        });
      }
      return undefined;
    }
  }

  private async selectLocationModal(locations: IGmbLocation[]) {
    const modal = await this.modalCtrl.create({
      component: GmbAccountSelectComponent,
      componentProps: { locations },
    });

    await modal.present();

    const { data } = (await modal.onDidDismiss()) as {
      data: { index: number };
    };

    return data;
  }

}
